module.exports = __webpack_public_path__ + "static/img/login-img.9b220f6a.png";